import { useContext, useState } from "react";
import { Box, Button, Heading, Text, useToast } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { UserProfileContext } from "../context/UserContext";
import http, { AUTH_ROUTES } from "../services/api";

export const ClearTamper = () => {
  const { activeAccount } = useContext(UserProfileContext) || {};
  const estateKey = activeAccount?.estateId || "default";

  // Try dashboard data in Redux first (same pattern as Steps.jsx)
  const dashboardMeterNumber = useSelector((state) => {
    const estateData = state?.switchTab?.dashboardData?.[estateKey] || {};
    // Check all commodities for a meter number
    for (const comm of ["water", "electricity", "gas"]) {
      const m = estateData?.[comm]?.creditCard?.meterNumber;
      if (m && m !== "N/A") return m;
    }
    return null;
  });

  const meterId =
    dashboardMeterNumber ||
    activeAccount?.meterNumbers?.water ||
    activeAccount?.meterNumbers?.electricity ||
    activeAccount?.meterNumbers?.gas;
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const toast = useToast();

  const handleClearTamper = async () => {
    if (!meterId) {
      toast({
        title: "No meter ID found",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    setToken(null);
    try {
      const res = await http.post(AUTH_ROUTES.CLEAR_TAMPER, { meterId });
      const receivedToken = res?.data?.result?.data?.token || null;
      if (receivedToken) {
        setToken(receivedToken);
      } else {
        toast({
          title: "Tamper cleared successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (e) {
      toast({
        title: e?.response?.data?.result?.message || "Failed to clear tamper",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p="30px" borderRadius="10px" bg="#fff" boxShadow="lg">
      <Heading size="md" mb="20px">
        Clear Tamper
      </Heading>
      {meterId && (
        <Text fontSize="sm" color="#777" mb="16px">
          Meter ID: {meterId}
        </Text>
      )}
      <Button
        colorScheme="red"
        mb="24px"
        isLoading={loading}
        onClick={handleClearTamper}
      >
        Clear Tamper
      </Button>

      {token && (
        <Box
          mt="8px"
          mb="24px"
          p="16px"
          bg="green.50"
          border="1px solid"
          borderColor="green.200"
          borderRadius="10px"
        >
          <Text fontSize="sm" color="green.700" fontWeight="semibold" mb="6px">
            Tamper cleared — your token:
          </Text>
          <Text
            fontFamily="mono"
            fontSize="22px"
            fontWeight="bold"
            letterSpacing="2px"
            color="green.600"
          >
            {token}
          </Text>
        </Box>
      )}

      <Text fontWeight="bold" mb="12px">
        Guidelines:
      </Text>
      <Text fontSize="sm" color="#555">
        Ensure the meter is accessible and powered before clearing tamper. If
        the issue persists after clearing, please contact support.
      </Text>
    </Box>
  );
};

export default ClearTamper;
